import { render, staticRenderFns } from "./B2BDetailOsmakeChange.vue?vue&type=template&id=ed53ca4e&scoped=true"
import script from "./B2BDetailOsmakeChange.vue?vue&type=script&lang=js"
export * from "./B2BDetailOsmakeChange.vue?vue&type=script&lang=js"
import style0 from "./B2BDetailOsmakeChange.vue?vue&type=style&index=0&id=ed53ca4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed53ca4e",
  null
  
)

export default component.exports